import { capitalizeAll } from '../../../shared/utils/format/format';
import { getSiteLogoUrl } from '../../../shared/utils/site/site';

import {
  AddressData,
  CountryData,
  Maybe,
  StoreReviewRatingData
} from '../../../shared/types/graphql-types';

type AggregateRating = {
  '@type': string;
  ratingValue: number;
  reviewCount: number;
};

type AddressCountryData = CountryData & { '@type': string };

type Address = {
  addressCountry: AddressCountryData;
  addressLocality: Maybe<string> | undefined;
  addressRegion: Maybe<string> | undefined;
  postalCode: Maybe<string> | undefined;
  streetAddress: string;
};

export function getStoreLD(
  storeAddress: AddressData,
  rating: StoreReviewRatingData
) {
  if (!storeAddress) return null;

  const { country, line1, line2, postalCode, phone, region, town } =
    storeAddress;

  const storeLD: Record<
    string,
    undefined | Maybe<string> | string[] | AggregateRating | Address
  > = {
    '@context': 'http://schema.org',
    '@type': 'TireShop',
    address: {
      '@type': 'PostalAddress',
      addressCountry: {
        '@type': 'Country',
        name: country?.isocode
      },
      addressLocality: capitalizeAll(town),
      addressRegion: region?.isocodeShort,
      postalCode,
      streetAddress: capitalizeAll(`${line1}${line2 ? ` ${line2}` : ''}`)
    },
    currenciesAccepted: 'USD',
    image: getSiteLogoUrl(),
    name: window.siteName,
    openingHours: [
      'Mo-Fr 8:00 AM - 6:00 PM',
      'Sa 8:00 AM - 5:00 PM',
      'Su CLOSED'
    ],
    paymentsAccepted: 'Cash, credit card',
    priceRange: '$',
    telephone: phone,
    url: window.location.href.split('?')[0] // will be ignored by JSON.stringify but will cause TS validation to pass below
  };

  if (rating && rating.numberOfReviews > 0) {
    storeLD.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: rating.rating,
      reviewCount: rating.numberOfReviews
    };
  }

  return JSON.stringify(storeLD);
}
